import { render, staticRenderFns } from "./subVendorProducts.vue?vue&type=template&id=7262c554&"
import script from "./subVendorProducts.vue?vue&type=script&lang=js&"
export * from "./subVendorProducts.vue?vue&type=script&lang=js&"
import style0 from "./subVendorProducts.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports